'use client';

import type { PropsWithChildren } from 'react';
import { r3f } from '../_helpers/global';

export const UseCanvas = (props: PropsWithChildren) => {
	return <r3f.In>{props.children}</r3f.In>;
};
